
export default [

  {
    path: '/consultar_cartera_procesoclinico',
    name: 'consultar_cartera_procesoclinico',
    component: () => import('@/views/procesoclinico/Carteraprocesoclinico.vue'),
    meta: {
      pageTitle: 'Cartera Proceso Clinico',
      breadcrumb: [
        
        {
          text: 'Proceso Clinico',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'consultar_cartera_proceso',
      accion1: { url: '/crear_procesoclinico' },
      pdf: true,
      excel: true
    },
  },
  {
    path: '/crear_procesoclinico',
    name: 'crear_procesoclinico',
    component: () => import('@/views/procesoclinico/EditarprocedimientoV2.vue'),
    meta: {
      pageTitle: 'Crear Proceso Clinico',
      breadcrumb: [
        {
          text: 'Procesos Clinicos',
          to: '/consultar_cartera_procesoclinico',
        },
        {
          text: 'Crear Proceso Clinico',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'crear_procesoclinico',
    },
  },
]
